module.exports = "h2{font-size:1em;text-transform:uppercase;color:#495057}textarea{width:100%;min-height:400px;resize:none}\n"